<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Icon, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, TabContent, TabPane } from "sveltestrap";
  import { error, success } from "../../../../../public/my-theme";
  import type { Fn } from "../../../../global";
  import type { Denounced } from "../../../../Model/Denounced";
  import type { Third } from "../../../../Model/Third";
  import DenouncedInfoForm from "../../DenouncedInfoForm.svelte";
  import { denouncedGenderService, denouncedService } from "../../../../services";
  import type { DenouncedGender } from "../../../../Model/DenouncedGender";
import ParamSelect from "../../../ParamSelect.svelte";

  export let agressorThird: Third;
  export let diligenceId: string;
  export let open = false;
  export let toggle: Fn = undefined;

  $: load(diligenceId, agressorThird)

  let size = "lg";
  let agressor: Denounced;
  let agressorGender: DenouncedGender;

  const dispatch = createEventDispatcher();

  async function load(diligenceId, agressorThird){
    if (diligenceId && agressorThird) {

      let agressors: Denounced[] = await denouncedService.findByDiligenceNumber(diligenceId)
      agressor = agressors.find(c => c.denouncedThirId == agressorThird.id)

      if (agressor) {
        agressorGender = await denouncedGenderService.findOneByDiligenceNumber(agressor.diligenceNumber);
      }

    }
  }

  async function saveDenouncedTraffic() {
    try {
      save()
      toggle()
      success("Datos guardados con exito");
    } catch (err) {
      error("Comprueba los campos");
    }
  }

  async function changeThirdList(third){
    agressor.denouncedThirId = third.id;
    agressorGender.denouncedThirId = third.id;
    save()
  }

  async function save(){
    await Promise.all([ 
      denouncedService.saveDenounced(agressor),
      denouncedGenderService.saveDenouncedGender(agressorGender)
    ])

    dispatch('saveDenounced');
  }


</script>

<Modal isOpen={open} {toggle} {size}>
  <ModalHeader {toggle}>Editar</ModalHeader>
  <ModalBody>

    <TabContent>
      <TabPane tabId="Datas" tab="Datos" active>
        {#if agressor}
          <DenouncedInfoForm denounced={agressor} on:changeThirdLIst={(event) => changeThirdList(event.detail)}/>
        {/if}
      </TabPane>
      {#if agressorGender}
      <TabPane tabId="2" tab="Situación">
        <div class="row">
          <div class="col-12 mt-3">
            <Label>Situación económica</Label>
            <Input
              type="textarea"
              rows={6}
              bind:value={agressorGender.economicSituation}
            />
          </div>
          <div class="col-12 col-sm-6 mt-3">
            <Label>Profesión</Label>
            <ParamSelect
              bind:paramSelectId={agressorGender.profesionId}
              paramType="profession"
              nothing={true}
            />
          </div>
          <div class="col-12 col-sm-6 mt-3">
            <Label>Situación laboral</Label>
            <ParamSelect
              bind:paramSelectId={agressorGender.employmentSituation}
              paramType="workSituation"
              nothing={true}
            />
          </div>
          <div class="col-12 mt-3">
            <Label>Centro de trabajo</Label>
            <ParamSelect
              bind:paramSelectId={agressorGender.employmentSituation}
              paramType="bussiness"
              nothing={true}
            />
          </div>
          <div class="col-12 col-sm-6 mt-3">
            <Label>Estado de Salud</Label>
            <ParamSelect
              bind:paramSelectId={agressorGender.healthStatus}
              paramType="healthStatus"
              nothing={true}
            />
          </div>
          <div class="col-12 col-sm-6 mt-3">
            <Label>Temperamento</Label>
            <Input type="text" bind:value={agressorGender.temperament} />
          </div>
        </div>
      </TabPane>
      <TabPane tabId="5" tab="Antecedentes">
        <div class="row">
          <div class="col-12 col-sm-6 mt-3">
            <Label >Antecedentes V. género</Label>
            <Input type="select" value={agressorGender.criminalRecord.toString()} >
              <option value="true">Si</option>
              <option value="false">No</option>
            </Input>
          </div>
          <div class="col-12 col-sm-6 mt-3">
            <Label >Cumplimiento de las cargas familiares</Label>
            <Input type="select" value={agressorGender.familyResponsibilities.toString()}  >
              <option value="true">Si</option>
              <option value="false">No</option>
            </Input>
          </div>
          <div class="col-12 mt-3">
            <Label >Lugares que frecuenta</Label>
            <Input
              type="textarea"
              rows={6}
              bind:value={agressorGender.frequentPlaces}
            />
          </div>

          <div class="col-12 mt-3">
            <Label >Adicciones</Label>
            <Input
              type="textarea"
              rows={6}
              bind:value={agressorGender.addictions}
            />
          </div>
        </div>
      </TabPane>
      {/if}

    </TabContent>
    <!-- <DiligenceDenouncedTrafficData agressorGender={agressorGender} diligenceId={diligenceId} /> -->

  </ModalBody>
  <ModalFooter>
    <button class="btn btn-success" type="button" on:click={saveDenouncedTraffic}>Guardar</button>
  </ModalFooter>
</Modal>

